export interface ProductSection {
  name: string;
  selectors: string[];
}

export interface PlatformSelectors {
  sections: ProductSection[];
  gallery: string;
  variantForm: string;
}

export const WOOCOMMERCE_SELECTORS: PlatformSelectors = {
  gallery: ".woocommerce-product-gallery",
  variantForm: ".variations_form",
  sections: [
    { name: "gallery", selectors: [".woocommerce-product-gallery"] },
    {
      name: "description",
      selectors: [
        ".woocommerce-Tabs-panel--description",
        ".woocommerce-product-details__short-description",
        ".woocommerce-product-details",
      ],
    },
    { name: "reviews", selectors: ["#reviews", "#tab-reviews", ".woocommerce-Reviews"] },
    { name: "specs", selectors: ["#tab-additional_information"] },
    { name: "shipping", selectors: [".woocommerce-shipping-destination"] },
    { name: "variants", selectors: [".variations_form", ".product-variations"] },
    { name: "price", selectors: [".price", "p.price"] },
  ],
};

export const SHOPIFY_SELECTORS: PlatformSelectors = {
  gallery: "[data-product-media], .product__media, .product-media",
  variantForm: "variant-selects, .product-form, form[action*='/cart/add']",
  sections: [
    { name: "gallery", selectors: ["[data-product-media]", ".product__media", ".product-media"] },
    { name: "description", selectors: [".product__description", ".product-single__description", ".rte"] },
    { name: "reviews", selectors: [".product-reviews", "#shopify-product-reviews", ".shopify-product-reviews"] },
    { name: "specs", selectors: [".product__accordion", ".product-accordions"] },
    { name: "shipping", selectors: [".product-shipping", "[data-shipping-info]"] },
    { name: "variants", selectors: ["variant-selects", ".product-form__variants"] },
    { name: "price", selectors: [".price", "[data-product-price]"] },
  ],
};

/** Resolve the first matching element for a section config. */
export function resolveSectionElement(section: ProductSection): Element | null {
  for (const sel of section.selectors) {
    const el = document.querySelector(sel);
    if (el) return el;
  }
  return null;
}

export function resolveGalleryElement(gallerySelector: string): Element | null {
  return document.querySelector(gallerySelector);
}

export function resolveVariantForm(variantFormSelector: string): HTMLFormElement | null {
  return document.querySelector(variantFormSelector);
}
